module.exports = __webpack_public_path__ + "img/gbicon.3ee54a2e.svg";